import styles from "../styles/FloatingButtons.module.css";
import { useEffect, useState } from "react";

// logo / icons
import { IoCall } from "react-icons/io5";
import { AiFillMessage } from "react-icons/ai";
import facebook from "../images/footer/facebook.webp";
import whatsapp from "../images/footer/whatsapp.webp";

function FloatingButtons() {
  const [showFloating, setShowFloating] = useState(false);

  useEffect(() => {
    const onScroll = () => setShowFloating(window.scrollY > 120);
    window.addEventListener("scroll", onScroll, { passive: true });
    onScroll(); // run once on mount
    return () => window.removeEventListener("scroll", onScroll);
  }, []);
  return (
    <div
      className={`${styles.floatingButtons} ${
        showFloating ? styles.isVisible : ""
      }`}
    >
      <a
        href="https://www.facebook.com/profile.php?id=61577330197696"
        target="_blank"
        rel="noopener noreferrer"
        className={styles.floatingFacebook}
        aria-label="Profixer on Facebook"
      >
        <img
          loading="lazy"
          src={facebook}
          alt="Facebook icon – Profixer Door Services"
        />
      </a>
      <a
        href="https://wa.me/+14036907147"
        target="_blank"
        rel="noopener noreferrer"
        className={styles.floatingWhatsapp}
        aria-label="WhatsApp Profixer"
      >
        <img
          loading="lazy"
          src={whatsapp}
          alt="WhatsApp chat – Profixer Door Services"
        />
      </a>
      <a
        href="sms:+14036907147"
        className={styles.floatingMessage}
        aria-label="Message Profixer Door Services"
      >
        <AiFillMessage />
      </a>
      <a
        href="tel:+14036907147"
        className={styles.floatingCall}
        aria-label="Call Profixer Door Services"
      >
        <IoCall />
      </a>
    </div>
  );
}

export default FloatingButtons;
